import { createApp } from 'vue';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from './firebase'; // firebase.jsからインポートするだけ
import App from './App.vue';
import router from './router';
import store from './store';

let vueApp;

onAuthStateChanged(auth, (user) => {
  store.dispatch('auth/fetchUser', user);

  if (!vueApp) {
    vueApp = createApp(App);
    vueApp.use(store);
    vueApp.use(router);
    vueApp.mount('#app');
  }
});